import { Component, OnInit, AfterViewInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { UserService } from '../users-module/services/user.service';
import { AuthService } from '../services/auth.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-auth-sso',
  templateUrl: './auth-sso.component.html',
  styleUrls: ['./auth-sso.component.css']
})
export class AuthSsoComponent implements OnInit, AfterViewInit {
  UserName : string;
  LoginError : boolean;
  ValidationMessage : string;
  NameValid : boolean;
  userNameSet : Subject<string> = new Subject<string>();
  userNameSaveComplete : boolean = false;

  $authCmplt : Subscription;
  constructor(private location : Router, public cookies : CookieService, private toast : ToastrService, private users : UserService, public activatedRoute: ActivatedRoute, public auth : AuthService) { 

  }

  ngAfterViewInit(): void {
    // debugger;
    var JWT = this.cookies.get('resIq');
    if(JWT){
      
      this.$authCmplt = this.auth.roleFetchComplete.subscribe((evt : boolean)=>{
        this.location.navigateByUrl('/dashboard');
      });
      localStorage.removeItem('STP-JWT');
      localStorage.setItem('STP-JWT', JWT);
      this.cookies.delete('resIq');
      this.auth.GetLoggedInUser();
     
    }else{
      this.toast.error('There was an error logging you in. please contact support for assistance.', 'Auto Login Failure.')
      this.location.navigateByUrl('/login')
    }
  }

  ngOnInit() {
  }
}
